// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min.js';

// Import everything from autoload
import "./autoload/_bootstrap.js"


// base font awesome
import fontawesome from "@fortawesome/fontawesome";
// individual icons
import faUser from "@fortawesome/fontawesome-free-solid/faUser";
import faEnvelope from "@fortawesome/fontawesome-free-solid/faEnvelope";
import faLaptop from "@fortawesome/fontawesome-free-solid/faLaptop";
import faMapMarkerAlt from "@fortawesome/fontawesome-free-solid/faMapMarkerAlt";
import faPhone from "@fortawesome/fontawesome-free-solid/faPhone";
import faSearchPlus from "@fortawesome/fontawesome-free-solid/faSearchPlus";
import faBars from "@fortawesome/fontawesome-free-solid/faBars";

// add the imported icons to the library
fontawesome.library.add(faUser, faEnvelope, faLaptop, faMapMarkerAlt, faPhone, faSearchPlus, faBars);

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateMap from './routes/map';
import singleAttraction from './routes/attraction';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  templateMap,
  //single attraction page
  singleAttraction,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js